<template>
	<auth-layout>
		<v-responsive min-height="100vh" class="d-flex align-center" slot="content">
			<main-container centered>
				<ValidationObserver ref="observer" v-slot="{ failed }">
					<material-card class="px-5 py-3" max-width="400" color="white">
						<v-img :src="$appOptions.systemLogo()" slot="image" class="py-5" contain>
							<template v-slot:placeholder>
								<v-sheet>
									<v-skeleton-loader type="image"></v-skeleton-loader>
								</v-sheet>
							</template>
						</v-img>
						<div slot="after-heading" class="text-caption">
							{{ $t("user.verify_tooltip") }}
						</div>
						<material-alert v-if="authError != null" :title="$t('errormessage.' + authError)" color="warning"></material-alert>
						<template slot="actions">
							<v-col cols="12" xs="12" sm="8" v-if="canAskNewVerify">
								<action-button color="warning" @click="sendNewVerifyMail()" outlined block :disabled="is_authloading" :text="$t('user.asknewverify')"></action-button>
							</v-col>
							<v-col cols="6" xs="6" v-else>
								<action-button @click="login()" outlined block :disabled="is_authloading" :text="$t('user.login')"></action-button>
							</v-col>
						</template>
					</material-card>
				</ValidationObserver>
			</main-container>
		</v-responsive>
	</auth-layout>
</template>

<script>
export default {
	computed: {
		authError() {
			return this.$store.getters.getAuthError;
		},
		is_authloading() {
			return this.$store.getters.is_authloading;
		},
		canAskNewVerify() {
			if (this.authError == "expired_link") {
				return true;
			}
			return false;
		},
	},
	methods: {
		login() {
			const self = this;
			self.$router.push({
				path: "/",
			});
		},
		sendNewVerifyMail() {
			let $wrong = false;
			if (this.$route.query) {
				let $expires = this.$route.query.expires;
				let $signature = this.$route.query.signature;
				if (this.$route.params) {
					let params = {
						id: this.$route.params.id,
						hash: this.$route.params.hash,
						expires: $expires,
						signature: $signature,
					};
					this.$store.dispatch("askNewVerifyEmail", params).then((res) => {
						if (res.message) {
							this.$router.push("/");
						}
					});
				} else {
					$wrong = true;
				}
			} else {
				$wrong = true;
			}
			if ($wrong == true) {
				this.$store.commit("authError", "malformed_link");
			}
		},
	},
	watch: {},
	beforeCreate() {
		if (this.$store.getters.isAuthenticated) {
			this.$store.dispatch("logout");
		}
		let $wrong = false;
		if (this.$route.query) {
			let $expires = this.$route.query.expires;
			let $signature = this.$route.query.signature;
			if (this.$route.params) {
				let params = {
					id: this.$route.params.id,
					hash: this.$route.params.hash,
					expires: $expires,
					signature: $signature,
				};
				this.$store.dispatch("verifyEmail", params).then((res) => {
					this.$router.push("/");
				});
			} else {
				$wrong = true;
			}
		} else {
			$wrong = true;
		}
		if ($wrong == true) {
			this.$store.commit("authError", "malformed_link");
		}
	},
};
</script>
